import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConstUserGroupEnum } from "../../../../models/ConstUserGroupEnum";
import { ObjectTypeNamesEnum } from "../../../../models/ObjectTypeEnum";
import { messagesApi } from "../../../../utils";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import BtnSelect from "../../../UI/Buttons/BtnSelect";
import InputCharLimit from "../../../UI/Inputs/InputCharLimit/InputCharLimit";
import InputText from "../../../UI/Inputs/InputText/InputText";
import HomePageBanner from "../../HomePage/HomePageBanner";
import classes from "./TeacherBanner.module.css";

const TeacherBanner = () => {

    const [inputs, setInputs] = useState()
    const [bannerData, setBannerData] = useState()
    const applicationId = useSelector(state => state.application.applicationId);
    const { texts, lang } = useSelector(state => state.translate);
    const uiData = useSelector((state) => state.general.uiData);
    const dispatch = useDispatch();
    const componentMounted = useRef(true);

    useEffect(() => {
        if (uiData) {
            const data = {
                refObjectType: ObjectTypeNamesEnum.Application,
                refObjectId: applicationId,
                targetObjects: [
                    { type: ObjectTypeNamesEnum.ConstUserGroup, id: ConstUserGroupEnum.Teacher },
                ],
                includeMessageTypesIds: [uiData.bannerMessageTypeId]
            }

            messagesApi.messagesFilterRangePost({ messagesRangeFilter: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.MessageContentMessagesFilterRange, error: error, statusCode: response?.statusCode, message: "MessagecontentMessagesFilterRange " + error.message, level: 2, component: "MessagesPage", line: 45 }))
                } else {
                    if (componentMounted.current) {
                        if (resdata.length > 0 && resdata[0].contents && resdata[0].contents.length > 0) {
                            const contents = {
                                he: { title: "", subTitle: "", btnText: "" },
                                ar: { title: "", subTitle: "", btnText: "" },
                                en: { title: "", subTitle: "", btnText: "" },
                            }
                            let link;
                            resdata[0].contents.forEach(c => {
                                contents[c.lang] = JSON.parse(c.content);
                                link = contents[c.lang].link
                            });
                            setInputs({
                                contents: contents,
                                link: link,
                                id: resdata[0].id
                            })
                            let bannerValues
                            if (contents[lang].title)
                                bannerValues = contents[lang]
                            else {
                                bannerValues = contents.he
                            }
                            setBannerData(bannerValues)
                        }
                    }
                }
            })
        }
    }, [applicationId, uiData])


    useEffect(() => {
        return () => {
            componentMounted.current = false;
        }
    }, [])


    const handleChange = (lang, name, value) => {
        setInputs(prev => {
            return { ...prev, contents: { ...prev.contents, [lang]: { ...prev.contents[lang], [name]: value } } };
        })
    }

    const save = () => {
        const jsonContents = { ...inputs.contents };
        Object.keys(jsonContents).forEach(c => jsonContents[c] = JSON.stringify({ ...jsonContents[c], link: inputs.link }))

        let data = {
            id: inputs.id,
            refObjectId: applicationId,
            refObjectType: ObjectTypeNamesEnum.Application,
            contents: jsonContents,
        }

        messagesApi.messagesUpdatePost({ messageAddOrUpdateInput: data }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.genralErrorMessage, error: error, statusCode: response?.statusCode, message: "genralErrorMessage " + error.message, level: 2, component: "MessageForm", line: 116 }))
            } else {
                let bannerValues;
                if (inputs.contents[lang].title)
                    bannerValues = inputs.contents[lang]
                else {
                    bannerValues = inputs.contents.he
                }
                setBannerData(bannerValues)
            }
        })
    }

    return <div className={classes.TeacherBanner}>
        {inputs && <div className={classes.Data}>
            <div className={classes.Part}>
                <div className={classes.Label}>{texts.title}</div>
                {Object.keys(inputs.contents).map(lang => <div className={classes.LangWrap}>
                    <InputCharLimit
                        limitNum={100}
                        name={`title${lang}`}
                        key={`title${lang}`}
                        type={"input"}
                        label={texts[lang]}
                        value={inputs.contents[lang].title}
                        setValue={(name, value) => handleChange(lang, "title", value)}
                        style={{ width: "503px" }}
                    ></InputCharLimit>
                </div>)}
            </div>
            <div className={classes.Part}>
                <div className={classes.Label}>{texts.subTitle}</div>
                {Object.keys(inputs.contents).map(lang => <div className={classes.LangWrap}>
                    <InputCharLimit
                        limitNum={100}
                        name={`subTitle${lang}`}
                        key={`subTitle${lang}`}
                        type={"input"}
                        label={texts[lang]}
                        value={inputs.contents[lang].subTitle}
                        setValue={(name, value) => handleChange(lang, "subTitle", value)}
                        style={{ width: "503px" }}
                    ></InputCharLimit>
                </div>)}
            </div>
            <div className={classes.Part}>
                <div className={classes.Label}>{texts.btnText}</div>
                {Object.keys(inputs.contents).map(lang => <div className={classes.LangWrap}>
                    <InputCharLimit
                        limitNum={100}
                        name={`btnText${lang}`}
                        key={`btnText${lang}`}
                        type={"input"}
                        label={texts[lang]}
                        value={inputs.contents[lang].btnText}
                        setValue={(name, value) => handleChange(lang, "btnText", value)}
                        style={{ width: "503px" }}
                    ></InputCharLimit>
                </div>)}
            </div>
            <div className={classes.Part}>
                <InputText label={texts.linkBtn} name={"link"} value={inputs.link} setValue={(name, value) => setInputs(prev => ({ ...prev, link: value }))}></InputText>
            </div>
            <BtnSelect checked={true} onClick={save} dropClass={classes.Btn} >{texts.change}</BtnSelect>
            <div className={classes.Preview}>
                <div className={classes.Label}>{texts.updateBanner}</div>
                <div className={classes.BannerWrapper}> <HomePageBanner {...bannerData}></HomePageBanner></div>
            </div>
        </div>}

    </div>
}
export default TeacherBanner;